import Vue from "vue/dist/vue.esm";
import Modal from "/shared/modal.vue";
import cookie from "/utils/cookie";
import { initModalVideo } from "/modules/modal-video";
import events from "/events/index";

const nodes = document.querySelectorAll("[data-modal]");
for (let i = 0; i < nodes.length; i++) {
  const el = nodes[i];
  const id = el.getAttribute("data-modal");

  if (cookie(`modal-${id}`)) {
    continue;
  }

  const stepsNodes = el.querySelectorAll("[data-modal-step]");
  const steps = {};
  let content;
  if (stepsNodes.length > 0) {
    for (let i = 0; i < stepsNodes.length; i++) {
      const stepsNode = stepsNodes[i];
      steps[stepsNode.dataset.modalStep] = stepsNode.innerHTML;
    }
  } else  {
    content = el.innerHTML;
  }
  const modifiers = el.dataset.modalModifiers ? el.dataset.modalModifiers.split(",") : [];

  new Vue({
    el,
    render: h => h(Modal, {
      props: {
        id,
        content,
        steps,
        timeout: el.dataset.modalTimeout,
        timeoutClose: el.dataset.modalTimeoutClose,
        cookie: el.dataset.modalCookie,
        trackingName: el.dataset.modalPiwikEventCategory,
        openActionName: el.dataset.modalPiwikEventAction,
        fixedSizes: el.dataset.modalFixedSizes === "true",
        modifiers
      }
    })
  });

  if (modifiers.indexOf("video") >= 0) {
    initModalVideo(id, el.dataset.modalYoutube);
  }
}

document.addEventListener("keydown", e => {
  if (e.code === "Escape") {
    events.emit("modal:all:close");
  }
});
